import React from "react";
import "../index.css"


const Images=(props)=>{

    return(
        <img  className="skill-images" src ={props.link} alt="Not found"/>
    )
}

export default Images